import svg4everybody from "svg4everybody";
import objectFitImages from "object-fit-images";
import objectFitVideos from "object-fit-videos";
import GLightbox from "glightbox";

import button from "../components/button/button";
import header from "../components/header/header";
import portfolio from "../templates/portfolio/portfolio";
import form from "../components/form/form";
import checkbox from "../components/form/checkbox";
import radio from "../components/form/radio";
import glide from "./partials/glide";
import slideInOut from "./partials/slideInOut";
import facetFilters from "../components/facet-filters/facet-filters";
import partnersGlider from "../components/partners/partners";
import quoteGlider from "../components/quote-large/quote-large";

const vGlobal = () => {
  header();
  slideInOut();
  portfolio();
  facetFilters();
  partnersGlider();
  form();
  checkbox();
  radio();

  if (document.querySelector(".v-quote-large")) {
    quoteGlider();
  }

  if (wpPostData.post_type === "project") {
    glide();
  }

	if (document.querySelector('.glightbox')) {
		const lightbox = GLightbox({
			selector: '.glightbox'
		});
	}

  /* const selects = document.querySelectorAll('select');
  [...selects].forEach(select => {
    const selectParent = select.parentNode;
    if (selectParent.classList.contains('v-form__select')) return;

    const wrapper = document.createElement('span');
    wrapper.classList.add('v-form__select');
    selectParent.insertBefore(wrapper, select);
    wrapper.appendChild(select);
  }); */

  function onWindowLoad() {
    svg4everybody();
    objectFitImages();
    objectFitVideos();
  }

  if (document.readyState === "complete") {
    onWindowLoad();
  } else {
    window.addEventListener("load", onWindowLoad);
  }
};

if (document.readyState != "loading") vGlobal();
else document.addEventListener("DOMContentLoaded", vGlobal);
